import { Blossom } from "./decor";

const PHRASES = [
  "BLOOMORA",
  "The Sweet Spot & Savouries",
  "ब्लूमोरा",
  "Where Every Meal Blooms",
  "Pure Vegetarian",
  "Dumka • Jharkhand",
];

export const Marquee = ({ className = "" }) => (
  <div
    data-testid="editorial-marquee"
    className={`relative overflow-hidden border-y border-[#C9A227]/30 bg-[#F3D9D9] py-5 ${className}`}
  >
    <div className="marquee-track items-center">
      {[0, 1].map((half) => (
        <div key={half} className="flex shrink-0 items-center" aria-hidden={half === 1}>
          {PHRASES.concat(PHRASES).map((p, i) => (
            <span key={`${half}-${i}`} className="flex items-center">
              <span
                className={`whitespace-nowrap px-8 text-2xl md:text-3xl ${
                  i % 3 === 2 ? "font-hindi text-[#9B2C2C]" : "font-serif italic text-[#9B2C2C]"
                }`}
              >
                {p}
              </span>
              <Blossom className="h-5 w-5 shrink-0 text-[#E8B4B8]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
